import { computed, Ref, ref } from '@vue/composition-api';
import { isEqual } from 'lodash-es';
import { useStore } from '@/core/store';

export default function useEditModel<Model> (
  name: string,
  id: string,
  defaultModel?: Model
): {
  model: Readonly<Ref<Model>>;
  modelChanges: Ref<Model>;
  editModel: (property: string, value: any) => void;
  modelInStore: Ref<Model>;
} {
  const store = useStore();

  const modelInStore = computed(() => {
    if (id !== 'new') {
      return store.getters[`entities/${name}`](id);
    } else if (defaultModel) {
      return defaultModel;
    }
  });

  const modelChanges: Ref<Model> = ref({});

  const model = computed(() => {
    return {
      ...modelInStore.value,
      ...modelChanges.value,
    };
  });

  function editModel (property: string, value: string): void {
    const dirty = !isEqual(modelInStore.value[property], value);
    if (dirty) {
      modelChanges.value = { ...modelChanges.value, [property]: value };
    } else {
      const clone = { ...modelChanges.value };
      delete clone[property];
      modelChanges.value = clone;
    }
  }

  return {
    model,
    modelChanges,
    editModel,
    modelInStore,
  };
}
